import { IcE57, IcRvt, IcTxt } from '../share/icons';

const icons = {
    rvt: IcRvt,
    txt: IcTxt,
    e57: IcE57,
};

export const getIcon = (type) => icons[type];
